import { render } from "./ClassificationsSelection.vue?vue&type=template&id=d08e96d2&ts=true"
import script from "./ClassificationsSelection.vue?vue&type=script&lang=ts"
export * from "./ClassificationsSelection.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Build\\TCF\\ABBp_PIS\\6.15.1\\PisNextGenExtProd-PisApp_6_15_1\\PisNextGenExtProd\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__